import {
    Box,
    Stack,
    Typography,
} from '@mui/material';
import {InputField} from '@/pages/components/common';
import {AuditProgramSectionVO} from '@/services/auditService/auditProgramService';
import type {D1_1Page} from '@/pages/components/audit-program/d-section/constants';
import {D1_1_PAGE} from '@/pages/components/audit-program/d-section/constants';
import ProgramSectionHeader from '@/pages/components/audit-program/a-section/ProgramSectionHeader';

export interface D1_1WorkingPaperViewProps {
    header: AuditProgramSectionVO;
    page: D1_1Page;
    refCode?: string;
    values: Record<string, string>;
    onChange: (key: string, value: string) => void;
}

/** D1.1 — Substantive analytical procedures working paper. */
export default function D1_1WorkingPaperView({
    header,
    page,
    refCode = 'D1.1',
    values,
    onChange,
}: D1_1WorkingPaperViewProps) {
    const meta = {
        title: page.title || D1_1_PAGE.title,
        note: page.note || D1_1_PAGE.note,
        sections: page.sections?.length ? page.sections : D1_1_PAGE.sections,
    };

    return (
        <Box sx={{p: 2}}>
            <ProgramSectionHeader
                header={header}
                variant="a12"
                refCode={refCode}
                values={values}
                onChange={onChange}
            />

            <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{textAlign: 'center', letterSpacing: 0.3, mb: 1.5, mt: 0.5}}
            >
                {meta.title}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{mb: 2, lineHeight: 1.45}}>
                {meta.note}
            </Typography>

            <Stack spacing={2}>
                {meta.sections.map((sec) => (
                    <Box key={sec.id}>
                        <Typography variant="subtitle2" fontWeight={700} sx={{mb: 0.75}}>
                            {sec.title}
                        </Typography>
                        <InputField
                            type="text"
                            fullWidth
                            compact
                            multiline
                            minRows={3}
                            value={values[sec.id] ?? ''}
                            onChange={(e) => onChange(sec.id, e.target.value)}
                        />
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
